import React from 'react';
import { func,array,string,number } from 'prop-types';
import style from './style';
import { RadioButtonGroup } from '../RadioButtonGroup/index';



const MultipleChoice = ({correctAnswer, targetOptions, answer, onAnswer, index})=>{
	const selectedIndex = targetOptions.findIndex(option=>option===answer);
	return (
		<style.AnswerLayout >
			<style.LabelLayout>{'('+(index+1)+')'}</style.LabelLayout>
			<RadioButtonGroup
				options={targetOptions}
				selectedIndex={selectedIndex}
				onSelect={(option,idx)=>{
					onAnswer && onAnswer(correctAnswer, idx, option);
				}}
			/>
		</style.AnswerLayout>
	);
};

MultipleChoice.propTypes = {
	correctAnswer : string,
	targetOptions : array,
	answer : string,
	onAnswer : func,
	index : number
};

export default MultipleChoice;